import React from 'react'
import * as R from 'ramda'
import { jt, t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'
import { Detail } from 'components/shared/Detail/Detail'

import { useArchiveJobsModalState } from './hooks'

import styles from './ArchiveJobsModal.module.scss'

export const ArchiveJobsModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
  archived,
}) => {
  const { state } = useArchiveJobsModalState()

  const { count, jobs, pks } = state

  const message = R.gt(R.length(pks), 0) ? (
    <Detail className={styles.detail} key="jobs">
      <Detail.Content
        chips={R.map(({ name }) => name, jobs)}
        type="chipsGroup"
      />
    </Detail>
  ) : null

  return (
    <DeleteResourceModal
      alert={
        archived
          ? jt`You are unarchiving ${count} jobs listed below: ${message}`
          : jt`You are archiving ${count} jobs listed below: ${message}`
      }
      className={styles.modal}
      message={
        archived
          ? t`Are you sure you want to unarchive?`
          : t`Are you sure you want to archive?`
      }
      title={archived ? t`Unarchive jobs` : t`Archive jobs`}
      confirmLabel={archived ? t`Unarchive` : t`Archive`}
      {...{ onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
